export default __webpack_public_path__ + "static/media/disqus.cb4ac2fe.svg";